// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header{background:rgba(34,34,34,.7);border-bottom:1px solid rgba(238,238,238,.02);height:65px;box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:0 20px;width:100%}.logo{display:flex;height:100%;align-items:center;justify-content:center}.logo img{height:32px;width:32px}.nativesStats div{font-size:12px;color:rgba(255,255,255,.7);text-align:left}", ""]);
// Exports
module.exports = exports;
